/**
 * PVE Template.
 * 
 * @todo @export
 *
 * @interface PveTemplate
 */
interface PvETemplate {

  /** PvE Template id. */
  _id: string;

  /** Active state. */
  active: boolean;

  /** PvE Template comments. */
  comments: any[];

  /** Creation date as ISO string. */
  created: string;

  /** Collection of child elements as element ids. */
  elements: ProjectElement['_id'][];

  /** Info as HTML string. */
  info: string;

  /** Collection of PvE Template logs. */
  logs: PvETemplateLog[];

  /** PvE Template name. */
  name: string;

  /** Last updated as ISO string. */
  updated: string;

  __v: number;
};
